import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../../styles/Pages/Blogs.module.scss"
import Link from 'next/link'
import { blogsData } from '../../data/BlogsData';
import { FacebookShareButton, FacebookIcon } from 'next-share';
import { WhatsappShareButton, WhatsappIcon } from 'next-share';
import { TwitterShareButton, TwitterIcon } from 'next-share';

export default function Blog({ blog, Allblogs }) {
    let filteredBlogs = Allblogs.filter(item => item.slug !== blog.slug);
    const similar_blogs = filteredBlogs;

    const handleClick = (e) => {
        gsap.registerPlugin(ScrollToPlugin);
        e.stopPropagation()
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: `#firstsec`,
                offsetY: 70,
            }
        })
    }

    return (
        <>
            <Head>
                <title>{blog.metaTitle}</title>
                <link rel="icon" href="/favicon.png" />
                <meta name="description" content={blog.metaDesc} />
                <link rel="canonical" href={`https://www.adventureresortkufri.com/blogs/${blog.slug}`} />
            </Head>
            <section className={styles.singleblog_top_banner} style={{ backgroundImage: `url(${blog.bannerImage})` }} >
                <div className={styles.banner_text}>
                    <div className='container common_title'>
                        <h1>{blog.title}</h1>
                    </div>
                </div>
            </section>
            <section className={`${styles.single_blog} common_padding`} id="firstsec">
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-8"'>
                            <div className="blogsocialWrap mb-2">
                                <h5>Share On: &nbsp;</h5>
                                <FacebookShareButton url={`https://www.adventureresortkufri.com/blogs/${blog.slug}`}>
                                    <FacebookIcon size={32} round />
                                </FacebookShareButton>
                                <WhatsappShareButton url={`https://www.adventureresortkufri.com/blogs/${blog.slug}`}>
                                    <WhatsappIcon size={32} round />
                                </WhatsappShareButton>
                                <TwitterShareButton url={`https://www.adventureresortkufri.com/blogs/${blog.slug}`}>
                                    <TwitterIcon size={32} round />
                                </TwitterShareButton>
                            </div>
                            <div className={`${styles.blog_text1} common_title`} dangerouslySetInnerHTML={{ __html: blog.content }}></div>
                        </div>
                        <div className={`${styles.recent_blog_sec} col-12 col-sm-12 col-md-4 col-lg-4`}>
                            <div className={`${styles.recent_top} common_title`}>
                                <h3 className='text-white'>Recent Posts</h3>
                            </div>
                            <div className={styles.recent_bottom}>
                                {similar_blogs && similar_blogs.slice(0, 5).map((item) => (
                                    <Link href={`/blogs/${item.slug}`} key={item.slug} className={styles.recent_bottom_main}>
                                        <div>
                                            <Image src={item.bgImage} alt={item.title} width={70} height={70}></Image>
                                        </div>
                                        <p className='m-0 ps-2'>{item.title}</p>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export const getStaticProps = async ({ params }) => {
    const Allblogs = blogsData
    const currentSlug = params.slug;
    const blog = blogsData.find((blog) => blog.slug === currentSlug) || {
        notfound: true,
    };
    return { props: { blog, Allblogs } };
};

export const getStaticPaths = async () => {
    const paths = blogsData.map((blog) => ({
        params: { slug: blog.slug },
    }));
    return { paths, fallback: false };
};
